import { AnimateHeight } from "@/scripts";

const BreadcrumbsModule = (breadcrumbs: HTMLDivElement) => {
  const toggle = (e: Event) => {
    const target = e.currentTarget as HTMLButtonElement;

    if (target.getAttribute("aria-expanded") === "false") {
      open(target);
    } else {
      close(target);
    }
  };

  const open = (target: HTMLButtonElement) => {
    const content = document.getElementById(
      target.getAttribute("aria-controls")!,
    ) as HTMLDivElement;

    target.setAttribute("aria-expanded", "true");
    AnimateHeight(content).toAutoHeight();
    content.classList.add("breadcrumbs--collapsed__container--visible");
  };

  const close = (target: HTMLButtonElement) => {
    const content = document.getElementById(
      target.getAttribute("aria-controls")!,
    ) as HTMLDivElement;

    target.setAttribute("aria-expanded", "false");
    AnimateHeight(content).toZeroHeight();
    content.classList.remove("breadcrumbs--collapsed__container--visible");
  };

  const init = () => {
    const triggers = breadcrumbs.querySelectorAll(
      ".js-breadcrumbs-toggler",
    ) as NodeListOf<HTMLButtonElement>;

    triggers.forEach((trigger) => trigger?.addEventListener("click", toggle));
  };

  return {
    init,
  };
};

const initiateBreadcrumbs = () => {
  document
    .querySelectorAll(".breadcrumbs")
    ?.forEach((breadcrumbs) =>
      BreadcrumbsModule(breadcrumbs as HTMLDivElement).init(),
    );
};

export { BreadcrumbsModule, initiateBreadcrumbs };
